import React from 'react';
import { Head, Link } from '@inertiajs/react';
import { Card } from '../../components/ui/card';

interface InviteSignupSuccessProps {
  token: string;
  inviteName?: string;
  userEmail: string;
}

const InviteSignupSuccess: React.FC<InviteSignupSuccessProps> = ({ 
  token, 
  inviteName,
  userEmail 
}) => {
  return (
    <div className="min-h-screen w-full bg-background flex items-center justify-center p-4 md:p-6 lg:p-8">
      <Head title="Account Created">
        <meta property="og:title" content="Account Created" />
        <meta property="og:description" content="Your account has been successfully created" />
        <meta property="og:image" content="https://hd.supavp.com/og-image.svg" />
        <meta property="og:url" content={`https://hd.supavp.com/public/invites/${token}`} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Account Created" />
        <meta name="twitter:description" content="Your account has been successfully created" />
        <meta name="twitter:image" content="https://hd.supavp.com/og-image.svg" />
      </Head>

      <div className="w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-foreground mb-2">
            Account Created!
          </h1>
          <p className="text-muted-foreground text-sm sm:text-base">
            Welcome to the community
          </p>
        </div>

        {/* Success Card */}
        <Card className="p-5 sm:p-6 md:p-8">
          <div className="flex flex-col items-center text-center space-y-6">
            {/* Success Icon */}
            <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-10 h-10 text-primary"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>

            {/* Success Message */}
            <div className="space-y-2">
              <p className="text-lg text-foreground">
                Your account has been created successfully!
              </p>
              <p className="text-sm text-muted-foreground">
                You've been signed in and can now access your dashboard.
              </p>
              {userEmail && (
                <p className="text-xs text-muted-foreground mt-2">
                  Account: {userEmail}
                </p>
              )}
            </div>

            {/* Dashboard Link */}
            <div className="pt-4 w-full">
              <Link
                href="/dashboard"
                className="block w-full"
              >
                <button className="w-full h-12 px-6 rounded-md font-medium bg-primary text-primary-foreground hover:bg-primary/90 transition-colors">
                  Go to Dashboard
                </button>
              </Link>
            </div>
          </div>
        </Card>

        {/* Footer */}
        <div className="text-center mt-6 text-xs sm:text-sm text-muted-foreground">
          <p>This invite link has been used and is now invalid.</p>
        </div>
      </div>
    </div>
  );
};

export default InviteSignupSuccess;
